<template>
  <div>
    <div id="menu-btn-opened" @click="closeMenu">
      <v-btn depressed class="custom-valid-btn-opened font-weight-medium">
        <v-icon style="padding-right:6px;margin-left:-3px;">mdi-account-circle</v-icon>{{ $t('account.title')}}
        <v-icon style="padding-left:6px;margin-right:-3px;">mdi-chevron-up</v-icon>
      </v-btn>
    </div>
    <v-card class="d-flex flex-column accountMenu" width="300px">
      <!-- <v-img src="https://www.mousquetaires.com/wp-content/uploads/2019/01/Intermarche_2.jpg" alt="magasin"></v-img> -->
      
      <div class="pa-4">
        <div class="d-flex flex-row" style="background-color">
          <div class="d-flex flex-column mb-3 text-left">
            <div class="d-flex flex-column mb-2" style="color:var(--v-primary-base)">
              <v-label class="caption">{{  $t('account.id')  }} :</v-label>
              <span> {{ $store.state.user.login }}</span>
            </div>
            <div class="d-flex flex-column" style="color:var(--v-primary-base)">
              <v-label class="caption">{{  $t('account.email')  }} :</v-label>
              <span> {{ $store.state.user.email }}</span>
            </div>
          </div>
        </div>
        <br>
        <v-text-field outlined rounded color="rgb(var(--connection-rgb))" v-on:keyup.enter="changePassword" label="Nouveau mot de passe" type="password" v-model="password"></v-text-field>
        <v-btn block outlined rounded height="40px" class="text-none font-weight-medium custom-valid-btn connection" @click="changePassword">Changer de mot de passe</v-btn>
        <div class="error" style="border-radius:50em; margin-bottom:20px;background-color: rgb(var(--connection-rgb))!important; color:white!important;" v-html="error"/>
        <div class="success" style="border-radius:50em; margin-bottom:20px;" v-html="success"/>

        <!-- <v-btn block outlined rounded height="40px" class="text-none font-weight-medium custom-valid-btn connection">{{  $t('account.edit-info')  }}</v-btn> -->
        <!-- <v-select 
          :menu-props="{contentClass: 'customSelect'}"
          item-color="allsan"
          append-icon="mdi-chevron-down"
          class="my-3 custom account"
          :items="languages"
          v-model="selectedLanguage"
          @change="changeLanguage"
          item-text="language"
          item-value="value"
          :placeholder="$t('account.language')"
          :hide-details="true"
          filled
          rounded
          dense
        ></v-select> -->
        <div class="custom-center" style="display:flex; flex-direction: row;">
          <v-label>{{  $t('account.theme')  }}</v-label>
          <v-spacer></v-spacer>
          <div id="theme-selector-custom">
            <v-icon style="flex:0 0 auto;height:42px;width:42px;margin-right:6px;">mdi-white-balance-sunny</v-icon>
            <v-switch class="switch-custom" inset v-model="selectedTheme" @change="changeTheme" style="padding-top:9px;margin-right:-16px;"></v-switch>
            <v-icon style="flex:0 0 auto;height:42px;width:42px;">mdi-moon-waxing-crescent</v-icon>
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import SettingsService from '@/services/SettingsService'
import LoginService from '@/services/LoginService'
export default {
  data () {
    return {
      languages: [
        {value: 'fr', language: 'Français'},
        {value: 'en', language: 'English'}
      ],
      selectedLanguage: {language: this.$store.state.language},
      selectedTheme: false,
      password: '',
      error: '',
      success: ''
    }
  },
  methods: {
    async changeTheme () {
      sessionStorage.theme = this.selectedTheme ? 'dark' : 'light'
      this.$store.dispatch('setTheme', this.selectedTheme)
      this.$vuetify.theme.dark = this.selectedTheme
      await SettingsService.changeTheme({
        userID: this.$store.state.user.id,
        theme: this.selectedTheme
      })
      this.$parent.$parent.$parent.$parent.changeTheme()
    },
    async changeLanguage () {
      this.$store.dispatch('setLanguage', this.selectedLanguage)
      this.$root.$i18n.locale = this.selectedLanguage
      await SettingsService.changeLanguage({
        userID: this.$store.state.user.id,
        language: this.$store.state.language
      })
    },
    async changePassword () {
      if (this.password.length < 6) {
        this.error = 'Le mot de passe doit faire au moins 6 caractères'
        this.success = ''
      } else {
        const response = await LoginService.changePassword({
          userID: this.$store.state.user.id,
          password: this.password
        })
        if (response.status === 200) {
          this.error = ''
          this.success = 'Mot de passe mis à jour'
        } else {
          this.success = ''
          this.error = 'La modification du mot de passe a échouée'
        }
      }
      
      
    },
    closeMenu () {
      this.password = ''
      this.$parent.$parent.$parent.$parent.closeMenu()
    }
  },
  mounted () {
    this.selectedTheme = sessionStorage.theme === 'dark'
  }
}
</script>

<style scoped>

</style>
